import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'techCheckCssHelper',
    standalone: false
})
export class TechCheckCssHelperPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    switch (value){
      case 'Pass':
        return 'result-pass';
      case 'Fail':
        return 'result-fail';
      case 'Warning':
        return 'result-warning';
      default:
        return '';
    }
  }

}
